var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoading,
          expression: "isLoading"
        }
      ]
    },
    [
      _c("el-header", [
        _c("ul", { staticClass: "List-headr" }, [
          _c(
            "li",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.getList }
                },
                [_vm._v("刷新")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isSspUser
            ? _c(
                "li",
                [
                  _c("span", [_vm._v("所属广告主：")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        size: "small",
                        filterable: "",
                        "filter-method": _vm.filteredAdvertiser
                      },
                      on: {
                        "visible-change": _vm.advertiserSelectVisibleChanged,
                        change: function($event) {
                          _vm.myOption.restStartPage()
                          _vm.getList()
                        }
                      },
                      model: {
                        value: _vm.selectUser,
                        callback: function($$v) {
                          _vm.selectUser = $$v
                        },
                        expression: "selectUser"
                      }
                    },
                    _vm._l(_vm.userData, function(item, index) {
                      return _c(
                        "el-option",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.visible,
                              expression: "item.visible"
                            }
                          ],
                          key: index,
                          attrs: {
                            label: item.advertiserName,
                            value: item.advertiserId
                          }
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(_vm._s(item.advertiserName))
                          ]),
                          _vm._v(" "),
                          item.advertiserName !== "全部"
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "right",
                                    color: "#8492a6",
                                    "font-size": "11px",
                                    "margin-left": "20px"
                                  }
                                },
                                [_vm._v(_vm._s(item.advertiserId))]
                              )
                            : _vm._e()
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("span", [_vm._v("出价类型：")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { size: "small" },
                  on: {
                    change: function($event) {
                      _vm.myOption.restStartPage()
                      _vm.getList()
                    }
                  },
                  model: {
                    value: _vm.selectType,
                    callback: function($$v) {
                      _vm.selectType = $$v
                    },
                    expression: "selectType"
                  }
                },
                _vm._l(
                  _vm.myOption.selectNull.concat(_vm.myOption.bidType),
                  function(item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: item.name, value: item.id }
                    })
                  }
                ),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("span", [_vm._v("日期：")]),
              _vm._v(" "),
              _c("el-date-picker", {
                attrs: {
                  size: "small",
                  "value-format": "yyyyMMdd",
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  clearable: false,
                  "picker-options": _vm.expireTimeOption
                },
                on: { change: _vm.getList },
                model: {
                  value: _vm.time,
                  callback: function($$v) {
                    _vm.time = $$v
                  },
                  expression: "time"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.setExport }
                },
                [_vm._v("导出")]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-main",
        { staticClass: "ListMain" },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.tableData, height: "100%" } },
            [
              _c("el-table-column", {
                key: "1",
                attrs: {
                  prop: "createDay",
                  label: "日期",
                  "min-width": "150px",
                  fixed: "left"
                }
              }),
              _vm._v(" "),
              _vm.isSspUser
                ? _c("el-table-column", {
                    key: "2",
                    attrs: {
                      prop: "advertiserName",
                      label: "广告主名称",
                      "min-width": "200px"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("div", [
                                _vm._v(_vm._s(scope.row.advertiserName))
                              ]),
                              _vm._v(" "),
                              scope.row.advertiserId
                                ? _c("div", { staticClass: "id-col" }, [
                                    _vm._v(
                                      "ID: " + _vm._s(scope.row.advertiserId)
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2063709039
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                key: "3",
                attrs: {
                  prop: "simulateBid",
                  label: "消耗（元）",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _vm.selectType !== ""
                ? _c("el-table-column", {
                    key: "4",
                    attrs: {
                      prop: "bidType",
                      label: "出价类型",
                      "min-width": "120px"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                key: "5",
                attrs: { prop: "bidNum", label: "竞价量", "min-width": "120px" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "6",
                attrs: {
                  prop: "showNum",
                  label: "展示量",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "7",
                attrs: {
                  prop: "clickNum",
                  label: "点击量",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "8",
                attrs: {
                  prop: "clickRatio",
                  label: "点击率(%)",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "9",
                attrs: { prop: "cpm", label: "预估CPM", "min-width": "120px" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "10",
                attrs: { prop: "cpc", label: "预估CPC", "min-width": "120px" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "24",
                attrs: {
                  prop: "activateNum",
                  label: "转化量",
                  "min-width": "140px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "11",
                attrs: {
                  prop: "downStartNum",
                  label: "下载开始量",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "12",
                attrs: {
                  prop: "downFinishNum",
                  label: "下载完成量",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "13",
                attrs: {
                  prop: "installStartNum",
                  label: "安装开始量",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "14",
                attrs: {
                  prop: "installFinishNum",
                  label: "安装完成量",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "15",
                attrs: {
                  prop: "packageOpenNum",
                  label: "通过包名打开量",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "16",
                attrs: {
                  prop: "deepinkOpenNum",
                  label: "应用唤醒量",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "17",
                attrs: {
                  prop: "playStartNum",
                  label: "播放开始量",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "18",
                attrs: {
                  prop: "playInterruptNum",
                  label: "播放中断量",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "19",
                attrs: {
                  prop: "playEndNum",
                  label: "播放结束量",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "20",
                attrs: {
                  prop: "adSkipNum",
                  label: "广告跳过量",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "21",
                attrs: {
                  prop: "adCloseNum",
                  label: "广告被关闭量",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "22",
                attrs: {
                  prop: "fullScreenNum",
                  label: "全屏播放量",
                  "min-width": "120px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                key: "23",
                attrs: {
                  prop: "startCardNum",
                  label: "点击预览图播放量",
                  "min-width": "140px"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-footer",
        [_c("Pagination", { attrs: { getList: _vm.getList } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26a19a56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26a19a56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ad_owner/Chart.vue
// module id = eZM0
// module chunks = 1